<template>
  <div>
    <component :is="'Library'" :list="list">
      <div slot="banner" class="join-banner">
        <div class="banner-container col col-6 md-6">
          <p class="h2">
            {{ $c.text('pages.courses.join') }}
          </p>
          <div class="expert-instructors">
            Take {{ $config.platform === 'ds' ? 'data science' : 'finance' }} courses from expert instructors from
            <div class="logos">
              <span v-for="(logo, idx) in companies" :key="idx" class="logo">
                <component :is="logo" />
              </span>
            </div>
            Develop an invaluable skillset and land your dream job in {{ $config.platform === 'ds' ? 'data and AI' :
              'finance' }}.
          </div>
          <nuxt-link to="/signup/" class="btn-primary" data-event="start_your_career_3.click">
            {{ $c.text('button.start-now') }}
          </nuxt-link>
        </div>
      </div>
    </component>
    <Lazy :when-visible="{ rootMargin: '200px' }">
      <div v-if="list.upcoming.length" class="upcoming-courses course">
        <div class="container">
          <div class="col-10 offset-1 md-12 md-offset-0">
            <Slider :disabled="list.upcoming.length <= 3" dark>
              <h3 slot="heading" class="h3">
                Upcoming Courses
              </h3>
              <nuxt-link slot="controls" to="/upcoming-courses/">
                Show All
              </nuxt-link>
              <div
                v-for="course in list.upcoming" :key="course.id" slot="slide"
                class="col col-4 sm-6 upcoming-wrapper"
              >
                <nuxt-link class="upcoming-course" :to="`/upcoming-courses/#${course.id}`">
                  <div class="image">
                    <div v-if="$config.platform === 'ds'" class="icon" :class="course.technology">
                      <img
                        :src="require(`@itbpbg/lms-components/src/assets/svg/tech-responsive-${course.technology.replace(' ', '-')}.svg`)"
                      >
                    </div>
                    <img
                      loading="lazy" :src="`${$config.imagesUrl}/upcoming-courses/${course.instructorPhoto}`"
                      :alt="course.instructor"
                    >
                  </div>
                  <div class="info">
                    <h4 class="h5">
                      {{ course.name }}
                    </h4>
                    <div class="instructors">
                      with {{ course.instructor }}
                    </div>
                  </div>
                </nuxt-link>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </Lazy>
  </div>
</template>

<script>
import Lazy from 'vue-lazy-hydration';
import Library from '@itbpbg/lms-components/src/Courses/Library';
import Slider from '@itbpbg/lms-components/src/components/Slider';
import LogoMeta from '@itbpbg/lms-components/src/assets/svg/companies/logo-meta-new.svg?vue-component';
import LogoNetflix from '@itbpbg/lms-components/src/assets/svg/companies/logo-netflix.svg?vue-component';
import LogoSpotify from '@itbpbg/lms-components/src/assets/svg/companies/logo-spotify.svg?vue-component';
import LogoInstagramIcon from '@itbpbg/lms-components/src/assets/svg/companies/logo-instagram-icon.svg?vue-component';
import LogoHsbc from '@itbpbg/lms-components/src/assets/svg/companies/logo-hsbc.svg?vue-component';
import LogoMorganStanley from '@itbpbg/lms-components/src/assets/svg/companies/logo-morgan-stanley.svg?vue-component';
import LogoGoldmanSachs from '@itbpbg/lms-components/src/assets/svg/companies/logo-goldman-sachs.svg?vue-component';
import LogoPwc from '@itbpbg/lms-components/src/assets/svg/companies/logo-pwc-new.svg?vue-component';
import LogoCocaCola from '@itbpbg/lms-components/src/assets/svg/companies/logo-coca-cola-auto.svg?vue-component';

export default {
  components: {
    Lazy,
    Library,
    Slider,
    LogoMeta,
    LogoSpotify,
    LogoNetflix,
    LogoInstagramIcon,
    LogoHsbc,
    LogoMorganStanley,
    LogoGoldmanSachs,
    LogoPwc,
    LogoCocaCola,
  },
  async asyncData({ $axios }) {
    const {
      modules, courses, page, upcoming, tracks, topics, technologies,
    } = await $axios.$get('/courses');

    let popularCourses = courses.filter((c) => c.popular).slice(0, 3);
    const inProgress = courses.filter((c) => (c.progress > 0 || c.started) && !c.completed).sort((a, b) => new Date(b.latestCompleted) - new Date(a.latestCompleted));
    const [progress] = inProgress;
    if (progress) {
      const lastPopular = popularCourses.find((p) => p.id === progress.id);
      if (!lastPopular) {
        popularCourses[0] = progress;
      } else {
        popularCourses = [
          progress,
          ...popularCourses.filter((p) => p.id !== progress.id),
        ];
      }
    }

    return {
      list: {
        modules, courses, page, popular: popularCourses, upcoming, tracks, topics, technologies,
      },
    };
  },
  data: () => ({
    list: {
      modules: [],
      courses: [],
      upcoming: [],
      page: null,
    },
  }),
  computed: {
    companies() {
      if (this.$config.platform === 'fa') {
        return [
          'LogoHsbc',
          'LogoMorganStanley',
          'LogoGoldmanSachs',
          'LogoPwc',
          'LogoCocaCola',
        ];
      }

      return [
        'LogoMeta',
        'LogoSpotify',
        'LogoNetflix',
        'LogoInstagramIcon',
        'LogoCocaCola',
      ];
    },
  },
};
</script>

<style lang="scss">
.courses-list {
  .course-library {
    margin-top: var(--spacing-60);
    padding-bottom: var(--spacing-100);
  }

  .courses-slider .slide .info>div {
    font-size: 14px;
  }

  aside .menu ul {
    margin-top: var(--spacing-16);
    position: relative;

    li.active-background {
      display: none;
      background-color: var(--main-light-shade-2);
      border-radius: 3px;
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      z-index: -1;
      transition: top var(--duration) ease-in;
    }
  }
}

.join-banner {
  align-items: center;
  border-radius: 0;
  background-repeat: no-repeat;
  background-size: cover;
  height: 706px;
  padding: 220px var(--spacing-24);
  background-image: linear-gradient(180deg, rgba(26, 38, 70, 0.1) 100%, #1A2646 100%), url("../../assets/images/courses-banner.jpg");
  display: flex;
  justify-content: center;
  color: var(--main-light);
  text-align: center;
  position: relative;
  overflow: hidden;
  background-size: cover;

  .banner-container {
    margin: 0 auto;
  }

  .expert-instructors {
    color: var(--main-light-shade-4);
    font-size: 21px;

    .logos {
      display: flex;
      justify-content: center;
      margin: 8px auto 20px;

      .logo {
        margin: 0 18px;
      }
    }

    svg {
      height: 24px;
    }
  }

  p:not(.h2) {
    line-height: 29px;
    margin: 0;
  }

  a {
    margin-top: var(--spacing-48);
    max-width: 300px;
    width: 100%;
    line-height: 33px;
    font-size: 18px;
  }

  .icons {
    position: absolute;
    bottom: -110px;
    left: 0;
    right: 0;

    &:before,
    &:after {
      content: '';
      display: block;
      width: 147px;
      height: 100%;
      position: absolute;
      top: 0;
    }

    &:before {
      background: linear-gradient(90deg, var(--main-dark) 0%, rgba(0, 12, 31, 0.7) 41.67%, rgba(0, 12, 31, 0) 100%);
    }

    &:after {
      right: 0;
      background: linear-gradient(270deg, var(--main-dark) 0%, rgba(0, 12, 31, 0.7) 41.67%, rgba(0, 12, 31, 0) 100%);
    }

    img {
      height: 200px;
    }
  }
}

.upcoming-courses.course {
  background-color: var(--main-dark-shade-1);
  color: var(--main-light);
  padding-top: var(--spacing-100);
  padding-bottom: var(--spacing-120);
  position: relative;
  z-index: 2;

  .slider-header {
    .h3 {
      margin: 0;
    }
  }

  .upcoming-wrapper {
    transition: transform var(--duration) ease;
    padding-bottom: var(--spacing-8);

    &:hover {
      transform: scale(1.03);
    }

    .upcoming-course {
      display: block;
      background-color: var(--main-dark-shade-2);
      border-radius: 7px;
      overflow: hidden;
      height: 100%;
      color: var(--main-light);

      .image {
        position: relative;
        height: 220px;

        .icon {
          position: absolute;
          right: 28px;
          top: 20px;
          z-index: 1;

          img {
            max-width: 44px;
            height: 100%;
            width: 100%;
            filter: drop-shadow(0 2px 10px rgba(0, 12, 31, 0.5));
          }
        }

        >img {
          width: 100%;
          height: 100%;
          -o-object-fit: cover;
          object-fit: cover;
          object-position: 100%;
        }
      }

      .info {
        padding: var(--spacing-24);

        .h5 {
          margin-top: 0;
          margin-bottom: var(--spacing-16);
        }

        .instructors {
          color: var(--main-light-shade-4);
          line-height: 18px;
        }
      }
    }
  }
}

@include bp($bp-laptop) {
  .upcoming-courses.course .upcoming-wrapper .upcoming-course .image {
    height: 193px;
  }

  .join-banner {
    a {
      max-width: 225px;
    }
  }
}

@include bp($bp-mobile) {
  .courses-list .course-library {
    margin-bottom: 0;

    .join-banner {
      margin-top: 82px;
      padding: var(--spacing-80) var(--spacing-24) 0 var(--spacing-24);
      border-radius: 0;

      a {
        line-height: 18px;
      }

      .icons {

        &:before,
        &:after {
          display: none;
        }

        img {
          width: 100%;
          height: 140px;
          object-fit: cover;
          object-position: center;
          display: block;
        }
      }
    }
  }

  .upcoming-courses.course {
    background: var(--main-light-shade-1);
    padding-bottom: var(--spacing-80);

    .slider-header {
      h3 {
        color: var(--main-dark-shade-0);
      }
    }

    .slider-container.dark .dots .dot:after {
      background-color: rgba(0, 12, 31, 0.36);
    }

    .slider-container.dark .dots .dot.active:after {
      background-color: var(--main-dark);
    }
  }
}

@include bp($bp-phone) {
  .join-banner {
    height: 583px;

    .icons {
      bottom: 0;

      &:before,
      &:after {
        content: none;
      }
    }
  }
}

@import '@itbpbg/lms-components/src/assets/sass/fa/pages/courses-page.scss';

.fa {
  .courses.list {
    .join-banner {
      background-image: linear-gradient(180deg, rgba(26, 38, 70, 0.1) 96%, #1A2646 100%), url("../../assets/images/fa/fa-courses-banner.jpg");
    }

    @include bp($bp-phone) {
      .join-banner {
        background-image: url("../../assets/images/fa/fa-courses-banner-mobile.jpg");
      }
    }
  }
}

.courses-list {
  @include bp($bp-phone) {
    .join-banner {
      background-image: url("../../assets/images/courses-banner-mobile.jpg");
      background-size: cover;
      padding: var(--spacing-60) var(--spacing-24);
      height: auto;
      outline: 1px solid var(--main-dark);

      .banner-container {
        .body-1 {
          line-height: 150%;
          color: var(--accent-light-2);
        }
      }

      .expert-instructors .logos {
        flex-wrap: wrap;
        gap: 6px;
      }
    }
  }
}
</style>
